import {useEffect} from 'react';
import {useParams} from 'react-router-dom';

const useTitle = (title: string) => {
  const params = useParams();
  const workspace = params.workspace ?? '';

  useEffect(() => {
    if (document) {
      const contents = [title, workspace.toUpperCase(), 'DasAR Admin'].filter(Boolean);
      document.title = contents.join(' | ');
    }
  }, [title, workspace]);
};

export default useTitle;
